<template>
    <div class="videoStudy" style="max-width: 1200px;margin: 0 auto;">
        <div class="main">
            <video style="width: 100%;" controls oncontextmenu="return false;" controlsList="nodownload noremote footbar"
                autoplay :src="dataObject.mediaPath_url"></video>
        </div>
        <div class="footer">
            <div class="xing">
                <span>评分：</span> <a-rate v-model="score" allow-half @change="scoreChange" />
            </div>
            <div class="pingyu">
                <a-textarea v-model="comment" placeholder="请输入您的评价" :auto-size="{ minRows: 3, maxRows: 5 }" />
            </div>
            <div>
                <a-button type="primary" style="float: right;" @click="postComment">提交评论</a-button>
            </div>
        </div>
        <a-row>
            <a-col :span="24">
                <a-list class="comment-list" item-layout="horizontal" :data-source="commentList">
                    <a-list-item slot="renderItem" slot-scope="item">
                        <a-comment :author="item.nickname" :avatar="item.avatar">
                            <div style="padding: 0 20px;margin: 0;display: inline-block;" slot="content">
                                <a-rate disabled v-model="item.score"  />
                                <span style="display:block;">{{ item.comment }}</span>
                            </div>
                            <span slot="datetime">{{ item.createTime }} </span>
                        </a-comment>
                    </a-list-item>
                </a-list>
            </a-col>
        </a-row>
    </div>
</template>
<script>
import { getAction, postAction } from '@/api/manage'
export default {
    name: '',
    components: {},
    data() {
        return {
            dataObject: {},
            score: 0,
            comment: '',
            commentList: []
        }
    },
    created() {
        this.init()
        this.getCommentList()
    },
    mounted() { document.title= this.$route.query.name },
    methods: {
        init() {
            getAction('/teaching/teachingCourseUnit/unitMedia', { id: this.$route.query.id }).then(res => {
                if (res.code == 200) {
                    this.dataObject = res.result[0]
                }
            })
        },
        scoreChange(v){
            console.log(v , 'ffff')
            this.score = v
        },
        getCommentList() {
            getAction('/teaching/comment/queryCommentBySourceId', { id: this.$route.query.id, page: 1 }).then(res => {
                console.log(res, '评级列表')
                if (res.success) {
                    this.commentList = res.result
                }
            })
        },
        postComment() {
            postAction('/teaching/comment/saveComment', {
                sourceType: '3',
                sourceId: this.$route.query.id,
                comment: this.comment,
                score: this.score
            }).then(res => {
                if (res.success) {
                    this.$message.success('评价成功!')
                    this.getCommentList()
                    this.comment = ''
                    this.score = 0
                }
            })
        }
    }
}
</script>
<style lang='scss' scoped>
.videoStudy {
    .footer {
        width: 100%;
        padding: 20px;

        .pingyu {
            margin: 10px 0;
        }
    }
}
</style>
